// extracted by mini-css-extract-plugin
export default {"body":"ProvidersItemMainBody_body__rKUjs","scrollContainer":"ProvidersItemMainBody_scrollContainer__OAm4t","empty":"ProvidersItemMainBody_empty__bR4oX"};